var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-col w-full bg-[#f5f5f5] border-b-solid border-[6px] border-primary rounded-[10px]"},[_vm._t("main-content"),_vm._v(" "),_c('div',{staticClass:"border-b-solid border-1 border-[#ddd] w-full max-w-[90%] mx-auto"}),_vm._v(" "),_vm._t("additional-content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }